import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

type OperatorOption<T extends string> = { value: T; label: string };

type ActiveFilterOperatorProps<T extends string> = {
  options: OperatorOption<T>[];
  /** Wording for the ACTIVE operator — may differ from its menu label (a
   * single-value `in` reads "is", and a field can pin it via `operatorLabel`). */
  label: string;
  onChange: (operator: T) => void;
};

/**
 * Operator segment of a filter chip. A field offering one operator renders it
 * as static, non-interactive text — no cursor/hover affordance suggesting a
 * choice that isn't there. Two or more open a dropdown that rewrites the
 * field's operator in the URL.
 */
export const ActiveFilterOperator = <T extends string>({
  options,
  label,
  onChange,
}: ActiveFilterOperatorProps<T>) => {
  if (options.length <= 1) {
    return (
      <span className="flex items-center bg-bg-dark-min border-t border-b border-border-dark-min px-1 py-0.5 h-6 text-xs leading-4 text-text-dark-high shrink-0">
        {label}
      </span>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center bg-bg-dark-min hover:bg-bg-dark-low border-t border-b border-border-dark-min px-1 py-0.5 h-6 text-xs leading-4 text-text-dark-high transition shrink-0 cursor-pointer">
        {label}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        className="w-fit min-w-fit bg-bg-surface-elevate-low"
      >
        {options.map((option) => (
          <DropdownMenuItem
            key={option.value}
            onClick={() => onChange(option.value)}
            className="text-sm leading-5 font-normal text-text-dark-max"
          >
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
